import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service6_1.jpeg';

const overview = [
  'Enterprise Storage Solutions for business-critical applications',
  'Software-Defined Storage (SDS) with file and object storage architectures.',
  'High-Performance Storage Solutions including all-flash and hybrid platforms.',
  'Storage Networking Solutions for scalable and resilient data access.',
  'Data Protection Solutions covering backup and disaster recovery (DR).'
];

const features = [
  { title: 'SAN & NAS Solutions',      text: 'Enterprise storage area networks and network-attached storage systems' },
  { title: 'Hybrid Cloud Storage',     text: 'Seamless integration between on-premise and cloud storage' },
  { title: 'Data Backup & Recovery',   text: 'Automated backup solutions with disaster recovery capabilities' },
  { title: 'Performance Optimization', text: 'High-speed storage with optimized data access and retrieval' }
];

function StorageService() {
  return (
    <ServicePage
      title="Storage Solutions"
      subtitle="Secure, scalable, and high-performance storage infrastructure"
      img={img}
      imgAlt="Storage Solutions"
      overview={overview}
      features={features}
      backAnchor="storage"
    />
  );
}

export default StorageService;
